// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ShopReceiptPreview_wrapper__2oJYL","graystyle":"ShopReceiptPreview_graystyle___sEE8","divider":"ShopReceiptPreview_divider__3V4Ik"};